import React, { useState, useEffect } from "react";

const DmpCard = () => {
  const heroImages = [
    "https://codeforgovtech.in/wp-content/uploads/2025/01/DSC01375-scaled-e1737516671687.jpg",
    "https://codeforgovtech.in/wp-content/uploads/2025/01/DSC01375-scaled-e1737516671687.jpg",
    "https://codeforgovtech.in/wp-content/uploads/2025/01/DSC01841-2-scaled-e1737516962312.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroImages.length);
    }, 4000); // Change every 4 seconds
    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <div style={styles.container}>
      {/* ===== HERO + TEXT SECTION ===== */}
      <section style={styles.heroSection}>
        <div style={styles.imageWrapper}>
          {/* Carousel container */}
          <div style={styles.carousel}>
            {heroImages.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`DMP Team ${idx + 1}`}
                style={{
                  ...styles.heroImage,
                  opacity: idx === currentIndex ? 1 : 0,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  transition: "opacity 0.8s ease-in-out",
                }}
              />
            ))}
          </div>
          <div style={styles.imageAccent}></div>
        </div>

        <div style={styles.textWrapper}>
          <h1 style={styles.heading}>Dedicated Mentoring Program</h1>
          <p style={styles.paragraph}>

            C4GT has conducted four rounds of DMP since 2022 where selected students and working professionals get an opportunity to contribute to critical tech building blocks under the guidance of a dedicated mentor. They work closely with organisations building DPGs and open source technology for a period of 3 months on problem statements that have a population scale social impact and get a stipend of Rs. 1 Lakh.

          </p>
          <p style={styles.paragraph}>
            C4GT is an ecosystem initiative that nurtures the development and long-term maintenance of open-source products, particularly Digital Public Goods (DPGs), that drive population-scale social impact. By creating pathways for young talent to contribute to these products, we aim to build a stronger ecosystem together.
          </p>
        </div>
      </section>

    

      {/* ===== WHY PARTICIPATE SECTION ===== */}
      <section style={styles.whySection}>
        <h2 style={styles.sectionTitle}>Why Participate in DMP?</h2>
        <div style={styles.cardsGrid}>
          {cardsData.map((card, idx) => (
            <div
              key={idx}
              style={styles.card}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 25px rgba(217, 70, 140, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 6px 15px rgba(217, 70, 140, 0.08)";
              }}
            >
              <div style={styles.cardIcon}>{card.icon}</div>
              <h3 style={styles.cardTitle}>{card.title}</h3>
              <p style={styles.cardText}>{card.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

// ===== CARD DATA WITH SVG ICONS =====
const cardsData = [
  {
    icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#9c27b0"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
    ),
    title: "1:1 Mentorship & hands-on learning",
    text: "Work closely with mentors in problem-solving sessions, bootcamps, and deep-dives. Learn by doing with continuous guidance and feedback.",
  },
  {
    icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fb8c00"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
        <path d="M2 17l10 5 10-5"></path>
        <path d="M2 12l10 5 10-5"></path>
      </svg>
    ),
    title: "Career growth & opportunities",
    text: "Unlock extended internships, PPOs with top orgs, and a stipend while building a portfolio of real-world impact projects.",
  },
  {
    icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#ff6d00"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
        <line x1="9" y1="9" x2="9.01" y2="9"></line>
        <line x1="15" y1="9" x2="15.01" y2="9"></line>
      </svg>
    ),
    title: "Create impact at population scale",
    text: "Contribute to large-scale digital platforms and be part of a thriving community shaping meaningful, open technology for governance and public good.",
  },
];

// ===== STYLES (Inline, Responsive, Mobile-First) =====
const styles = {
  container: {
    fontFamily: "'Inter', 'Roboto', 'Segoe UI', sans-serif",
    backgroundColor: "#fff",
    color: "#333",
    lineHeight: "1.6",
    padding: "2rem 1rem",
  },

  // ===== HERO + TEXT =====
  heroSection: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    gap: "2rem",
    maxWidth: "1200px",
    margin: "0 auto 3rem auto",
    padding: "0 1rem",
  },
  imageWrapper: {
    flex: "1 1 300px",
    maxWidth: "420px",
    position: "relative",
    height: "350px", // Fixed height for smooth carousel
  },
  carousel: {
    position: "relative",
    width: "100%",
    height: "100%",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  imageAccent: {
    position: "absolute",
    bottom: "-8px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "40px",
    height: "4px",
    background: "linear-gradient(to right, #9c27b0, #e91e63)",
    borderRadius: "2px",
  },
  textWrapper: {
    flex: "1 1 500px",
    padding: "0.5rem 0",
  },
  heading: {
    fontSize: "clamp(1.8rem, 4vw, 2.2rem)",
    fontWeight: "700",
    color: "#1a1a1a",
    marginBottom: "1.2rem",
    lineHeight: "1.3",
  },
  paragraph: {
    fontSize: "clamp(0.95rem, 2.2vw, 1rem)",
    color: "#4b5563",
    marginBottom: "1rem",
    textAlign: "justify",
  },

  // ===== WHY PARTICIPATE =====
  whySection: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1rem",
  },
  sectionTitle: {
    fontSize: "clamp(1.7rem, 3.8vw, 2rem)",
    fontWeight: "700",
    color: "#1a1a1a",
    marginBottom: "2.5rem",
    textAlign: "center",
  },
  cardsGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1.5rem",
    justifyContent: "center",
  },
  card: {
    background: "linear-gradient(135deg, #fdf4f7 0%, #fce8f0 100%)",
    borderRadius: "18px",
    padding: "1.8rem",
    flex: "1 1 300px",
    maxWidth: "360px",
    boxShadow: "0 6px 15px rgba(217, 70, 140, 0.08)",
    transition: "all 0.3s ease",
    cursor: "default",
  },
  cardIcon: {
    marginBottom: "1rem",
    display: "flex",
    justifyContent: "flex-start",
  },
  cardTitle: {
    fontSize: "1.1rem",
    fontWeight: "700",
    color: "#1a1a1a",
    marginBottom: "0.7rem",
  },
  cardText: {
    fontSize: "0.94rem",
    color: "#555",
    lineHeight: "1.6",
  },

  // ===== INFO RIBBON =====
  infoRibbon: {
    background: "linear-gradient(90deg, #fceabb 0%, #f8b500 100%)",
    color: "#232942",
    fontWeight: 500,
    fontSize: "1.05rem",
    borderRadius: "12px",
    padding: "1.1rem 1.5rem",
    margin: "0 auto 2.5rem auto",
    maxWidth: "700px",
    boxShadow: "0 2px 12px rgba(248,181,0,0.08)",
    textAlign: "center",
    letterSpacing: "0.01em",
  },
};

export default DmpCard;